<div class="mydocma-dialog-container">

  <div class="mydocma-dialog-header">
    <div class="mydomca-dialog-header-title">
      {{'MM.fault.import.title' | translate }}
    </div>
    <div>
      <button mat-icon-button type="button" mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="mydocma-dialog-body">
    <div class="fi-dialog-content" [@.disabled]="isAnimationUnsupportedDevice" [class.anim-off]="isAnimationUnsupportedDevice">
      <mydocma-loader class="mydocma-mm-loader" [size]="'middle'"
                      *ngIf="importStepperService.isLoading"></mydocma-loader>

      <mydocma-mm-faults-import-stepper #stepperComponent
        [@.disabled]="isAnimationUnsupportedDevice"
        [class.anim-off]="isAnimationUnsupportedDevice"

      >

      </mydocma-mm-faults-import-stepper>


    </div>
  </div>

  <div class="mydocma-dialog-footer">
    <mydocma-fab class="mydocma-btn-secondary fi-fab-button-item" *ngIf="(this.importStepperService.stepperService?.currentStep$ && this.importStepperService.stepperService.currentStep$ | async)?.config.name === 'selectFile'" [button]="(fabButton$ | async)" style="margin-right: 10px">
    </mydocma-fab>

    <button mat-stroked-button type="submit" class="mydocma-btn" style="margin-right: 10px" (click)="onCancel()" >
      {{'MM.fault.import.buttonNext.cancel' | translate }}
    </button>
    <button mat-stroked-button type="button" class="mydocma-btn-primary" (click)="onNext()" [disabled]="!(importStepperService?.stepperService?.currStep?.completed ?? false) || this.faultsImportService.importStarted">
      {{ nextButtonText | translate }}
    </button>
  </div>
</div>
